// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wG_4","left":"styles_left__PVYpk"};